import axios from 'axios';

import { safe } from '../utility';

const { VUE_APP_COMMB_API_BASE_URL } = process.env;
const { VUE_APP_COMMB_API_USER_BASE_URL } = process.env;
const { VUE_APP_RECAPTCHA_SITE_KEY } = process.env;

/**
 * identification
 * @param {string} pid
 * @param {string} pin
 * @param {string} birth
 * @param {string} lang
 * @return {Promise<void>}
 * @throws {Promise<errorMessage>}
 */
async function identification(pid, pin, birth, lang) {
  await axios.post(`${VUE_APP_COMMB_API_BASE_URL}/identification`, {
    pid, pin, birth, action: 'identification', lang
  })
  .then(({ data }) => {
    const resultCode = safe(() => data.ResultCode);
    if (resultCode !== '0'){
      return Promise.reject(data.ErrorMessage);
    }
  }, error => Promise.reject(error.message));
}

/**
 * forgotpassword
 * @param {string} pid
 * @param {string} pin
 * @param {string} birth
 * @param {string} appType
 * @return {Promise<void>}
 * @throws {Promise<errorMessage>}
 */
async function forgotpass(pid, pin, birth, appType) {
  await axios.post(`${VUE_APP_COMMB_API_BASE_URL}/identification`, {
    pid, pin, birth, action: 'forgotpassword' , appType
  })
  .then(({ data }) => {
    const resultCode = safe(() => data.ResultCode);

    if (resultCode !== '0'){
      return Promise.reject(data.ErrorMessage);
    }
  }, error => Promise.reject(error.message));
}

/**
 * deviceInfo
 * @param {string} AppType
 * @param {string} DeviceAttributes
 * @param {string} config
 * @return {Promise<void>}
 * @throws {Promise<errorMessage>}
 */
async function deviceInfo(AppType, DeviceAttributes ,config) {
  try{
    const res = await axios.post(`${VUE_APP_COMMB_API_USER_BASE_URL}/users/me/deviceinfo`, {
      AppType, DeviceAttributes
    }, config)

    const resultCode = safe(() => res.data.ResultCode);
    if (resultCode !== '0'){
      throw res.data.ErrorMessage
    }
  }catch(error){
    throw error
  }

}

/**
 * activate
 * @param {string} AppType
 * @param {string} DeviceAttributes
 * @param {string} config
 * @return {Promise<void>}
 * @throws {Promise<errorMessage>}
 */
async function activate(AppType, DeviceAttributes ,config) {
  try{
    const res = await axios.post(`${VUE_APP_COMMB_API_USER_BASE_URL}/users/me/activate`, {
      AppType, DeviceAttributes
    }, config)

    const resultCode = safe(() => res.data.ResultCode);
    if (resultCode !== '0'){
      throw res.data.ErrorMessage
    }
  }catch(error){
    throw error
  }

}

/**
 * getRecaptchaV3Token
 * @return {string<reCaptchaToken>}
 * @throws {Promise<errorMessage>}
 */
async function getRecaptchaV3Token() {
  try{
    const reCaptchaToken = await grecaptcha.execute(VUE_APP_RECAPTCHA_SITE_KEY, {
      action: 'submit'
      })
      .then((reCaptchaToken) => reCaptchaToken);
  return reCaptchaToken;
  }catch(error){
    throw error
  }

}

/**
 * recapcthaV3Authenticate
 */
async function recapcthaV3Authenticate(recaptchaV3Token) {
  try{
    const result = await axios.post(`${VUE_APP_COMMB_API_BASE_URL}/recaptchav3`, {
      Token: recaptchaV3Token
    })
    .then((result) => result);
  return result.data;
  }catch(error){
    throw error
  }

}

/**
 * formMessage
 * @param {string} formId
 * @param {string} appType
 * @param {string} srvType
 * @param {string} lang
 * @return {Promise<void>}
 * @throws {Promise<errorMessage>}
 */
 async function formMessage(formId, appType, srvType, lang) {
  try{
    const res = await axios.post(`${VUE_APP_COMMB_API_BASE_URL}/formmessage`, {
      formId, appType, srvType, lang
    })

    const resultCode = safe(() => res.data.ResultCode);
    if (resultCode !== '0'){
      throw res.data.ErrorMessage
    }
    return res.data;
  }catch(error){
    throw error
  }

}

/**
 * phoneNumberIdentification
 * @param {string} appType
 * @param {string} pid
 * @param {string} pin
 * @param {string} birth
 * @param {string} phone
 * @param {string} useType
 * @param {string} lang
 * @return {Promise<void>}
 * @throws {Promise<errorMessage>}
 */
 async function phoneNumberIdentification(appType, pid, pin, birth, phone, useType, lang) {
  try{
    const res = await axios.post(`${VUE_APP_COMMB_API_BASE_URL}/phonenumberidentification`, 
    {
      AppType: appType,
      PID: pid,
      PIN: pin,
      Birthday: birth,
      PhoneNumber: phone,
      UseType: useType,
      lang: lang,
    })
    const resultCode = safe(() => res.data.ResultCode);
    if (resultCode !== '0'){
      throw res.data.ErrorMessage
    }
    return res.data;
  }catch(error){
    throw error
  }

}

/**
 * smsCodeAuthentication
 * @param {string} authCode
 * @param {string} smsAuthId
 * @param {string} lang
 * @return {Promise<void>}
 * @throws {Promise<errorMessage>}
 */
 async function smsCodeAuthentication(authCode, smsAuthId, lang) {
  try{
    const res = await axios.post(`${VUE_APP_COMMB_API_BASE_URL}/smscodeauthentication`, {
      AuthCode: authCode,
      SMSAuthId: smsAuthId, 
      lang: lang,
    })

    const resultCode = safe(() => res.data.ResultCode);
    if (resultCode !== '0'){
      throw res.data.ErrorMessage
    }
    return res.data;
  }catch(error){
    throw error
  }

}

/**
 * isOpenMaintenanceCheck
 * @param {boolean} isCrmCheck
 * @return {Promise<boolean>}
 */
 async function isOpenMaintenanceCheck(isCrmCheck = false) {
  const defaultReturn = false
  try{
    const res = await axios.post(`${VUE_APP_COMMB_API_BASE_URL}/maintenancecheck`, {
      isCrmCheck: isCrmCheck,
    })

    if (res.data.ResultCode !== '0'){
      return defaultReturn
    }
    return res.data.isOpen;
  }catch(error){
    return defaultReturn
  }
}

export {
  identification,
  forgotpass,
  deviceInfo,
  activate,
  getRecaptchaV3Token,
  recapcthaV3Authenticate,
  formMessage,
  phoneNumberIdentification,
  smsCodeAuthentication,
  isOpenMaintenanceCheck
};
